








import { Component, Vue } from 'vue-property-decorator'
import { USER_CENTER_URL } from '@/apps/open/constants'
import Button from '@/apps/open/components/Button'

@Component({
  components: {
    Button
  },
  data: () => ({
    USER_CENTER_URL
  })
})
export default class NoPhoneErrorDialogBody extends Vue {}
